// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.events-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 2rem 1rem;
  font-family: Arial, sans-serif;
}

.events-container h1 {
  font-size: 2rem;
  color: #1a1a2e;
  margin-bottom: 0.5rem;
}

.events-intro {
  color: #666;
  margin-bottom: 2rem;
  font-size: 1rem;
}

.section-title {
  font-size: 1.4rem;
  color: #00703C;
  border-left: 4px solid #00703C;
  padding-left: 0.75rem;
  margin: 2rem 0 1rem;
}

.no-events {
  color: #888;
  font-style: italic;
  padding: 1rem 0;
}

.events-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

/* NO position:relative on event-card — that was trapping the modal */
.event-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.09);
  overflow: hidden;
  transition: transform 0.2s, box-shadow 0.2s;
}

.event-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.13);
}

.event-card.past {
  opacity: 0.75;
  filter: grayscale(30%);
}

.event-image {
  position: relative;
  height: 180px;
  overflow: hidden;
  background: #f0f0f0;
}

.event-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.event-ticket-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #00703C;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  padding: 4px 10px;
  border-radius: 20px;
  z-index: 1;
}

.event-content {
  padding: 1rem 1.2rem 1.2rem;
}

.event-content h3 {
  font-size: 1.1rem;
  color: #1a1a2e;
  margin: 0 0 0.6rem;
}

.event-details {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 0.75rem;
}

.event-details div {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: #555;
}

.event-description {
  font-size: 0.9rem;
  color: #444;
  line-height: 1.5;
  margin-bottom: 1rem;
}

.sold-out-text { color: #dc3545; font-weight: bold; }

.free-event-note {
  font-size: 0.85rem;
  color: #28a745;
  font-weight: 500;
  margin-top: 0.5rem;
}

.ticket-btn {
  width: 100%;
  padding: 0.7rem;
  background: #00703C;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
}

.ticket-btn:hover:not(:disabled) { background: #005a30; }

.ticket-btn.sold-out {
  background: #ccc;
  cursor: not-allowed;
}

/* Modal — fixed to viewport via Portal, never clipped by card */
.ticket-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
  overflow-y: auto;
}

.ticket-modal {
  background: #fff;
  border-radius: 14px;
  padding: 2rem;
  width: 100%;
  max-width: 500px;
  margin: auto;
  position: relative;
  animation: slideUp 0.25s ease;
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}

.ticket-close {
  position: absolute;
  top: 14px;
  right: 16px;
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  color: #555;
  line-height: 1;
  padding: 4px;
}

.ticket-close:hover { color: #000; }

.ticket-modal-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 1.2rem;
}

.ticket-modal-header h2 {
  font-size: 1.4rem;
  color: #1a1a2e;
  margin: 0;
}

.ticket-event-summary {
  background: #f0f7f0;
  border-left: 4px solid #00703C;
  border-radius: 8px;
  padding: 0.9rem 1rem;
  margin-bottom: 1.4rem;
}

.ticket-event-summary h3 {
  font-size: 1rem;
  color: #1a1a2e;
  margin: 0 0 0.4rem;
}

.ticket-event-summary p {
  font-size: 0.85rem;
  color: #555;
  margin: 0.2rem 0;
  display: flex;
  align-items: center;
  gap: 5px;
}

.ticket-price-badge {
  display: inline-block !important;
  margin-top: 0.5rem;
  background: #00703C;
  color: #fff !important;
  border-radius: 20px;
  padding: 2px 12px;
  font-weight: bold;
  font-size: 0.85rem;
}

.ticket-form { display: flex; flex-direction: column; gap: 1rem; }

.ticket-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.ticket-field { display: flex; flex-direction: column; gap: 4px; }

.ticket-field label {
  font-size: 13px;
  font-weight: 600;
  color: #444;
}

.ticket-field input,
.ticket-field select {
  padding: 0.65rem 0.75rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 15px;
  outline: none;
  transition: border 0.2s;
  box-sizing: border-box;
  width: 100%;
}

.ticket-field input:focus,
.ticket-field select:focus { border-color: #00703C; }
.ticket-field input.error,
.ticket-field select.error { border-color: #dc3545; }

.err { font-size: 12px; color: #dc3545; }

.ticket-total {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 1.1rem;
}

.ticket-total strong { color: #00703C; font-size: 1.3rem; }

.stripe-card-wrapper {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px 14px;
  background: #fff;
  transition: border 0.2s;
}

.stripe-card-wrapper:focus-within { border-color: #00703C; }

.ticket-secure-note {
  font-size: 12px;
  color: #777;
  text-align: center;
  margin: 0;
}

.ticket-pay-btn {
  width: 100%;
  padding: 0.85rem;
  background: #00703C;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.2s;
}

.ticket-pay-btn:hover:not(:disabled) { background: #005a30; }
.ticket-pay-btn:disabled { background: #ccc; cursor: not-allowed; }

.ticket-success-modal { text-align: center; }

.ticket-success-modal h2 {
  font-size: 1.6rem;
  color: #1a1a2e;
  margin-bottom: 0.5rem;
}

.ticket-success-details {
  background: #f0f7f0;
  border-radius: 10px;
  padding: 1rem 1.2rem;
  margin: 1.2rem 0;
  text-align: left;
}

.ticket-success-details div {
  display: flex;
  justify-content: space-between;
  padding: 0.4rem 0;
  border-bottom: 1px solid #ddd;
  font-size: 0.95rem;
}

.ticket-success-details div:last-child { border-bottom: none; }
.ticket-success-details span { color: #666; }
.ticket-success-details strong { color: #1a1a2e; }

.ticket-ref {
  background: #00703C;
  color: #fff !important;
  padding: 2px 10px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.9rem;
}

.ticket-email-note {
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 1.2rem;
}

.ticket-close-btn {
  padding: 0.75rem 2.5rem;
  background: #00703C;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
}

.ticket-close-btn:hover { background: #005a30; }

@media (max-width: 500px) {
  .ticket-form-row { grid-template-columns: 1fr; }
  .ticket-modal    { padding: 1.4rem; }
}
/* ── Group pricing tiers ── */
.pricing-tiers {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
}

.pricing-tiers-title {
  font-size: 13px;
  font-weight: 600;
  color: #444;
  margin: 0 0 0.5rem;
  display: flex;
  align-items: center;
  gap: 5px;
}

.pricing-tiers-grid { display: flex; flex-direction: column; gap: 4px; }

.tier-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  padding: 4px 0;
  border-bottom: 1px solid #eee;
  color: #555;
}

.tier-row:last-child { border-bottom: none; }

.tier-tag {
  font-size: 11px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 10px;
  background: #e0e0e0;
  color: #555;
}

.tier-tag.green { background: #d4edda; color: #155724; }
.tier-tag.gold  { background: #fff3cd; color: #856404; }

.event-discount-badge {
  position: absolute;
  bottom: 10px;
  left: 10px;
  background: #ffc107;
  color: #333;
  font-size: 11px;
  font-weight: bold;
  padding: 3px 10px;
  border-radius: 20px;
}

/* ── Lead booker section ── */
.lead-booker-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
}

/* ── Quantity + price row ── */
.quantity-row {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.price-summary { width: 100%; }

.discount-badge {
  background: #d4edda;
  color: #155724;
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-align: center;
}

/* ── Attendee rows ── */
.attendees-section {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 1rem;
}

.attendees-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0;
  padding: 0.75rem 1rem;
  background: #f0f7f0;
  border-bottom: 1px solid #e0e0e0;
}

.attendee-row {
  display: flex;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f0f0f0;
  align-items: flex-start;
}

.attendee-row:last-child { border-bottom: none; }

.attendee-number {
  font-size: 13px;
  font-weight: bold;
  color: #00703C;
  min-width: 24px;
  padding-top: 28px;
}

.attendee-fields { flex: 1 1; display: flex; flex-direction: column; gap: 8px; }

/* ── Success attendees list ── */
.attendees-summary {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  margin: 0.75rem 0;
  text-align: left;
}

.attendees-summary-title {
  font-size: 13px;
  font-weight: 600;
  color: #444;
  margin: 0 0 0.5rem;
}

.attendee-summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #555;
  padding: 3px 0;
  border-bottom: 1px solid #eee;
}

.attendee-summary-row:last-child { border-bottom: none; }

.green-text { color: #28a745; }
/* ── Package selector ── */
.package-selector {
  margin-bottom: 1rem;
}

.package-selector-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 0.25rem;
}

.package-selector-sub {
  font-size: 12px;
  color: #888;
  margin: 0 0 0.75rem;
}

.packages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
  margin-bottom: 0.75rem;
}

.package-card {
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  padding: 0.85rem 0.75rem;
  text-align: center;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.package-card:hover:not(:disabled) {
  border-color: #00703C;
  background: #f0f7f0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,112,60,0.15);
}

.package-card.selected {
  border-color: #00703C;
  background: #e8f5e9;
  box-shadow: 0 4px 12px rgba(0,112,60,0.2);
}

.package-card.sold-out {
  opacity: 0.5;
  cursor: not-allowed;
  background: #f5f5f5;
}

.package-name {
  font-size: 16px;
  font-weight: 800;
  color: #1a1a2e;
  margin-bottom: 4px;
}

.package-size {
  font-size: 12px;
  color: #666;
  margin-bottom: 6px;
}

.package-price {
  font-size: 15px;
  font-weight: 700;
  color: #00703C;
}

.package-per-person {
  font-size: 11px;
  color: #888;
  margin-top: 2px;
}

.package-description {
  font-size: 11px;
  color: #555;
  margin-top: 6px;
  font-style: italic;
}

.package-sold-out {
  font-size: 11px;
  color: #dc3545;
  font-weight: bold;
  margin-top: 4px;
}

.package-selected-tick {
  position: absolute;
  top: 6px;
  right: 8px;
  font-size: 12px;
  color: #00703C;
  font-weight: bold;
}

.clear-package-btn {
  background: none;
  border: none;
  color: #888;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
  text-decoration: underline;
  margin-bottom: 0.5rem;
}

.clear-package-btn:hover { color: #dc3545; }

.package-divider {
  text-align: center;
  color: #bbb;
  font-size: 12px;
  margin: 0.75rem 0 0.5rem;
}

/* ── Selected package banner ── */
.selected-package-banner {
  background: #e8f5e9;
  border: 1px solid #00703C;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  color: #1a1a2e;
  margin-bottom: 1rem;
}
.quantity-input-row {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
  width: fit-content;
}

.qty-btn {
  width: 42px;
  height: 42px;
  background: #f0f0f0;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #333;
  transition: background 0.2s;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qty-btn:hover { background: #ddd; }

.qty-input {
  width: 60px;
  height: 42px;
  text-align: center;
  border: none;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  font-size: 16px;
  outline: none;
}

.attendee-booker-note {
  font-size: 12px;
  color: #888;
  font-style: italic;
  padding: 0 1rem 0.5rem;
  margin: 0;
  background: #f0f7f0;
}

.package-selector { margin-bottom: 1rem; }
.package-selector-title { font-size: 15px; font-weight: 700; color: #1a1a2e; margin: 0 0 0.25rem; }
.package-selector-sub { font-size: 12px; color: #888; margin: 0 0 0.75rem; }

.packages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 10px;
  margin-bottom: 0.75rem;
}

.package-card {
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  padding: 0.85rem 0.75rem;
  text-align: center;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.package-card:hover:not(:disabled) {
  border-color: #00703C;
  background: #f0f7f0;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,112,60,0.15);
}

.package-card.selected { border-color: #00703C; background: #e8f5e9; }
.package-card.sold-out { opacity: 0.5; cursor: not-allowed; background: #f5f5f5; }
.package-name { font-size: 16px; font-weight: 800; color: #1a1a2e; margin-bottom: 4px; }
.package-size { font-size: 12px; color: #666; margin-bottom: 6px; }
.package-price { font-size: 15px; font-weight: 700; color: #00703C; }
.package-per-person { font-size: 11px; color: #888; margin-top: 2px; }
.package-description { font-size: 11px; color: #555; margin-top: 6px; font-style: italic; }
.package-sold-out { font-size: 11px; color: #dc3545; font-weight: bold; margin-top: 4px; }
.package-selected-tick { position: absolute; top: 6px; right: 8px; font-size: 12px; color: #00703C; font-weight: bold; }

.clear-package-btn {
  background: none; border: none; color: #888;
  font-size: 12px; cursor: pointer; padding: 0;
  text-decoration: underline; margin-bottom: 0.5rem;
}
.clear-package-btn:hover { color: #dc3545; }
.package-divider { text-align: center; color: #bbb; font-size: 12px; margin: 0.75rem 0 0.5rem; }

.selected-package-banner {
  background: #e8f5e9; border: 1px solid #00703C;
  border-radius: 8px; padding: 10px 14px;
  font-size: 14px; color: #1a1a2e; margin-bottom: 1rem;
}

.pricing-tiers { background: #f8f9fa; border: 1px solid #e0e0e0; border-radius: 8px; padding: 0.75rem 1rem; margin-bottom: 1rem; }
.pricing-tiers-title { font-size: 13px; font-weight: 600; color: #444; margin: 0 0 0.5rem; display: flex; align-items: center; gap: 5px; }
.pricing-tiers-grid { display: flex; flex-direction: column; gap: 4px; }
.tier-row { display: flex; justify-content: space-between; align-items: center; font-size: 13px; padding: 4px 0; border-bottom: 1px solid #eee; color: #555; }
.tier-row:last-child { border-bottom: none; }
.tier-tag { font-size: 11px; font-weight: bold; padding: 2px 8px; border-radius: 10px; background: #e0e0e0; color: #555; }
.tier-tag.green { background: #d4edda; color: #155724; }
.tier-tag.gold  { background: #fff3cd; color: #856404; }

.event-discount-badge { position: absolute; bottom: 10px; left: 10px; background: #ffc107; color: #333; font-size: 11px; font-weight: bold; padding: 3px 10px; border-radius: 20px; }
.lead-booker-section { background: #f8f9fa; border-radius: 8px; padding: 1rem; margin-bottom: 1rem; }
.quantity-row { display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 1rem; }
.price-summary { width: 100%; }
.discount-badge { background: #d4edda; color: #155724; border-radius: 6px; padding: 6px 10px; font-size: 13px; font-weight: 600; margin-bottom: 0.5rem; text-align: center; }

.attendees-section { border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; margin-bottom: 1rem; }
.attendees-title { font-size: 14px; font-weight: 600; color: #333; margin: 0; padding: 0.75rem 1rem; background: #f0f7f0; border-bottom: 1px solid #e0e0e0; }
.attendee-row { display: flex; gap: 0.75rem; padding: 0.75rem 1rem; border-bottom: 1px solid #f0f0f0; align-items: flex-start; }
.attendee-row:last-child { border-bottom: none; }
.attendee-number { font-size: 13px; font-weight: bold; color: #00703C; min-width: 30px; padding-top: 28px; }
.attendee-fields { flex: 1 1; display: flex; flex-direction: column; gap: 8px; }

.attendees-summary { background: #f8f9fa; border-radius: 8px; padding: 0.75rem 1rem; margin: 0.75rem 0; text-align: left; }
.attendees-summary-title { font-size: 13px; font-weight: 600; color: #444; margin: 0 0 0.5rem; }
.attendee-summary-row { display: flex; justify-content: space-between; font-size: 13px; color: #555; padding: 3px 0; border-bottom: 1px solid #eee; }
.attendee-summary-row:last-child { border-bottom: none; }
.green-text { color: #28a745; }
/* ── Description clamp on card ── */
.event-description-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.4rem;
}

.read-more-link {
  display: inline-block;
  font-size: 0.82rem;
  color: #00703C;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 0.75rem;
  transition: color 0.15s;
}

.read-more-link:hover { color: #005a30; text-decoration: underline; }

/* ── Event Detail Modal ── */
.event-detail-modal {
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 620px;
  margin: auto;
  position: relative;
  animation: slideUp 0.25s ease;
  overflow: hidden;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.event-detail-image {
  position: relative;
  height: 240px;
  overflow: hidden;
  background: #f0f0f0;
  flex-shrink: 0;
}

.event-detail-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.event-detail-body {
  padding: 1.5rem 1.75rem 1.75rem;
  overflow-y: auto;
  flex: 1 1;
}

.event-detail-title {
  font-size: 1.5rem;
  color: #1a1a2e;
  margin: 0 0 1rem;
  padding-right: 1.5rem; /* avoid overlap with X button */
  line-height: 1.3;
}

.event-detail-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
}

.event-detail-meta div {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #555;
}

.event-detail-description {
  margin-bottom: 1.5rem;
}

.event-detail-description h4 {
  font-size: 0.95rem;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.event-detail-description p {
  font-size: 0.95rem;
  color: #444;
  line-height: 1.7;
  margin: 0;
  white-space: pre-wrap;
}

.event-detail-actions {
  margin-top: 0.5rem;
}

@media (max-width: 640px) {
  .event-detail-modal { max-height: 95vh; border-radius: 10px 10px 0 0; }
  .event-detail-image { height: 180px; }
  .event-detail-body  { padding: 1.2rem 1.2rem 1.5rem; }
  .event-detail-title { font-size: 1.25rem; }
}`, "",{"version":3,"sources":["webpack://./src/pages/Events.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA,qEAAqE;AACrE;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB,cAAc,EAAE,iBAAiB,EAAE;;AAEpD;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,mCAAmC,mBAAmB,EAAE;;AAExD;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gEAAgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;AACd;;AAEA,sBAAsB,WAAW,EAAE;;AAEnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,eAAe,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;;AAEjE;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEjE;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;;AAEA;6BAC6B,qBAAqB,EAAE;AACpD;6BAC6B,qBAAqB,EAAE;;AAEpD,OAAO,eAAe,EAAE,cAAc,EAAE;;AAExC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,uBAAuB,cAAc,EAAE,iBAAiB,EAAE;;AAE1D;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,oCAAoC,qBAAqB,EAAE;;AAE3D;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,uCAAuC,mBAAmB,EAAE;AAC5D,2BAA2B,gBAAgB,EAAE,mBAAmB,EAAE;;AAElE,wBAAwB,kBAAkB,EAAE;;AAE5C;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,yCAAyC,mBAAmB,EAAE;AAC9D,+BAA+B,WAAW,EAAE;AAC5C,iCAAiC,cAAc,EAAE;;AAEjD;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,mBAAmB,0BAA0B,EAAE;EAC/C,mBAAmB,eAAe,EAAE;AACtC;AACA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAEvE;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,WAAW;AACb;;AAEA,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;;AAEvD;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA,iBAAiB,WAAW,EAAE;;AAE9B;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA,2BAA2B,mBAAmB,EAAE;;AAEhD;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,mBAAmB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE7E,iCAAiC;AACjC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,cAAc;EACd,6BAA6B;AAC/B;;AAEA,mCAAmC,mBAAmB,EAAE;;AAExD,cAAc,cAAc,EAAE;AAC9B,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,UAAU;EACV,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,2BAA2B,cAAc,EAAE;;AAE3C;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,iBAAiB,gBAAgB,EAAE;;AAEnC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA,oBAAoB,mBAAmB,EAAE;AACzC,0BAA0B,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,mBAAmB,EAAE;AAClG,wBAAwB,eAAe,EAAE,WAAW,EAAE,mBAAmB,EAAE;;AAE3E;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,yBAAyB,qBAAqB,EAAE,mBAAmB,EAAE;AACrE,yBAAyB,YAAY,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACjF,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB,EAAE;AACvF,gBAAgB,eAAe,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAClE,iBAAiB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACpE,sBAAsB,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE;AACrE,uBAAuB,eAAe,EAAE,WAAW,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAC1F,oBAAoB,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE;AACzF,yBAAyB,kBAAkB,EAAE,QAAQ,EAAE,UAAU,EAAE,eAAe,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAEvH;EACE,gBAAgB,EAAE,YAAY,EAAE,WAAW;EAC3C,eAAe,EAAE,eAAe,EAAE,UAAU;EAC5C,0BAA0B,EAAE,qBAAqB;AACnD;AACA,2BAA2B,cAAc,EAAE;AAC3C,mBAAmB,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE,wBAAwB,EAAE;;AAE/F;EACE,mBAAmB,EAAE,yBAAyB;EAC9C,kBAAkB,EAAE,kBAAkB;EACtC,eAAe,EAAE,cAAc,EAAE,mBAAmB;AACtD;;AAEA,iBAAiB,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AACjI,uBAAuB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACzI,sBAAsB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACvE,YAAY,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,eAAe,EAAE,cAAc,EAAE,6BAA6B,EAAE,WAAW,EAAE;AAC7J,uBAAuB,mBAAmB,EAAE;AAC5C,YAAY,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,WAAW,EAAE;AACzH,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;;AAEvD,wBAAwB,kBAAkB,EAAE,YAAY,EAAE,UAAU,EAAE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AACpL,uBAAuB,mBAAmB,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACpG,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE,mBAAmB,EAAE;AACzF,iBAAiB,WAAW,EAAE;AAC9B,kBAAkB,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,kBAAkB,EAAE;;AAE5K,qBAAqB,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC3G,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,SAAS,EAAE,qBAAqB,EAAE,mBAAmB,EAAE,gCAAgC,EAAE;AAC5J,gBAAgB,aAAa,EAAE,YAAY,EAAE,qBAAqB,EAAE,gCAAgC,EAAE,uBAAuB,EAAE;AAC/H,2BAA2B,mBAAmB,EAAE;AAChD,mBAAmB,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE;AAC3G,mBAAmB,SAAO,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;;AAE7E,qBAAqB,mBAAmB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC1H,2BAA2B,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE,kBAAkB,EAAE;AAC/F,wBAAwB,aAAa,EAAE,8BAA8B,EAAE,eAAe,EAAE,WAAW,EAAE,cAAc,EAAE,6BAA6B,EAAE;AACpJ,mCAAmC,mBAAmB,EAAE;AACxD,cAAc,cAAc,EAAE;AAC9B,oCAAoC;AACpC;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,wBAAwB,cAAc,EAAE,0BAA0B,EAAE;;AAEpE,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,qBAAqB,EAAE,gCAAgC;EACvD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB,gBAAgB,EAAE,4BAA4B,EAAE;EACtE,sBAAsB,aAAa,EAAE;EACrC,sBAAsB,6BAA6B,EAAE;EACrD,sBAAsB,kBAAkB,EAAE;AAC5C","sourcesContent":[".events-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n  font-family: Arial, sans-serif;\n}\n\n.events-container h1 {\n  font-size: 2rem;\n  color: #1a1a2e;\n  margin-bottom: 0.5rem;\n}\n\n.events-intro {\n  color: #666;\n  margin-bottom: 2rem;\n  font-size: 1rem;\n}\n\n.section-title {\n  font-size: 1.4rem;\n  color: #00703C;\n  border-left: 4px solid #00703C;\n  padding-left: 0.75rem;\n  margin: 2rem 0 1rem;\n}\n\n.no-events {\n  color: #888;\n  font-style: italic;\n  padding: 1rem 0;\n}\n\n.events-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n/* NO position:relative on event-card — that was trapping the modal */\n.event-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.09);\n  overflow: hidden;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.event-card:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 20px rgba(0,0,0,0.13);\n}\n\n.event-card.past {\n  opacity: 0.75;\n  filter: grayscale(30%);\n}\n\n.event-image {\n  position: relative;\n  height: 180px;\n  overflow: hidden;\n  background: #f0f0f0;\n}\n\n.event-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.event-ticket-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: #00703C;\n  color: #fff;\n  font-size: 12px;\n  font-weight: bold;\n  padding: 4px 10px;\n  border-radius: 20px;\n  z-index: 1;\n}\n\n.event-content {\n  padding: 1rem 1.2rem 1.2rem;\n}\n\n.event-content h3 {\n  font-size: 1.1rem;\n  color: #1a1a2e;\n  margin: 0 0 0.6rem;\n}\n\n.event-details {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  margin-bottom: 0.75rem;\n}\n\n.event-details div {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.85rem;\n  color: #555;\n}\n\n.event-description {\n  font-size: 0.9rem;\n  color: #444;\n  line-height: 1.5;\n  margin-bottom: 1rem;\n}\n\n.sold-out-text { color: #dc3545; font-weight: bold; }\n\n.free-event-note {\n  font-size: 0.85rem;\n  color: #28a745;\n  font-weight: 500;\n  margin-top: 0.5rem;\n}\n\n.ticket-btn {\n  width: 100%;\n  padding: 0.7rem;\n  background: #00703C;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.ticket-btn:hover:not(:disabled) { background: #005a30; }\n\n.ticket-btn.sold-out {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n/* Modal — fixed to viewport via Portal, never clipped by card */\n.ticket-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.65);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 1rem;\n  overflow-y: auto;\n}\n\n.ticket-modal {\n  background: #fff;\n  border-radius: 14px;\n  padding: 2rem;\n  width: 100%;\n  max-width: 500px;\n  margin: auto;\n  position: relative;\n  animation: slideUp 0.25s ease;\n}\n\n@keyframes slideUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.ticket-close {\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  cursor: pointer;\n  color: #555;\n  line-height: 1;\n  padding: 4px;\n}\n\n.ticket-close:hover { color: #000; }\n\n.ticket-modal-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 1.2rem;\n}\n\n.ticket-modal-header h2 {\n  font-size: 1.4rem;\n  color: #1a1a2e;\n  margin: 0;\n}\n\n.ticket-event-summary {\n  background: #f0f7f0;\n  border-left: 4px solid #00703C;\n  border-radius: 8px;\n  padding: 0.9rem 1rem;\n  margin-bottom: 1.4rem;\n}\n\n.ticket-event-summary h3 {\n  font-size: 1rem;\n  color: #1a1a2e;\n  margin: 0 0 0.4rem;\n}\n\n.ticket-event-summary p {\n  font-size: 0.85rem;\n  color: #555;\n  margin: 0.2rem 0;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.ticket-price-badge {\n  display: inline-block !important;\n  margin-top: 0.5rem;\n  background: #00703C;\n  color: #fff !important;\n  border-radius: 20px;\n  padding: 2px 12px;\n  font-weight: bold;\n  font-size: 0.85rem;\n}\n\n.ticket-form { display: flex; flex-direction: column; gap: 1rem; }\n\n.ticket-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.ticket-field { display: flex; flex-direction: column; gap: 4px; }\n\n.ticket-field label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #444;\n}\n\n.ticket-field input,\n.ticket-field select {\n  padding: 0.65rem 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 15px;\n  outline: none;\n  transition: border 0.2s;\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.ticket-field input:focus,\n.ticket-field select:focus { border-color: #00703C; }\n.ticket-field input.error,\n.ticket-field select.error { border-color: #dc3545; }\n\n.err { font-size: 12px; color: #dc3545; }\n\n.ticket-total {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #f8f8f8;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-size: 1.1rem;\n}\n\n.ticket-total strong { color: #00703C; font-size: 1.3rem; }\n\n.stripe-card-wrapper {\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 12px 14px;\n  background: #fff;\n  transition: border 0.2s;\n}\n\n.stripe-card-wrapper:focus-within { border-color: #00703C; }\n\n.ticket-secure-note {\n  font-size: 12px;\n  color: #777;\n  text-align: center;\n  margin: 0;\n}\n\n.ticket-pay-btn {\n  width: 100%;\n  padding: 0.85rem;\n  background: #00703C;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.ticket-pay-btn:hover:not(:disabled) { background: #005a30; }\n.ticket-pay-btn:disabled { background: #ccc; cursor: not-allowed; }\n\n.ticket-success-modal { text-align: center; }\n\n.ticket-success-modal h2 {\n  font-size: 1.6rem;\n  color: #1a1a2e;\n  margin-bottom: 0.5rem;\n}\n\n.ticket-success-details {\n  background: #f0f7f0;\n  border-radius: 10px;\n  padding: 1rem 1.2rem;\n  margin: 1.2rem 0;\n  text-align: left;\n}\n\n.ticket-success-details div {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.4rem 0;\n  border-bottom: 1px solid #ddd;\n  font-size: 0.95rem;\n}\n\n.ticket-success-details div:last-child { border-bottom: none; }\n.ticket-success-details span { color: #666; }\n.ticket-success-details strong { color: #1a1a2e; }\n\n.ticket-ref {\n  background: #00703C;\n  color: #fff !important;\n  padding: 2px 10px;\n  border-radius: 4px;\n  font-family: monospace;\n  font-size: 0.9rem;\n}\n\n.ticket-email-note {\n  font-size: 0.85rem;\n  color: #555;\n  margin-bottom: 1.2rem;\n}\n\n.ticket-close-btn {\n  padding: 0.75rem 2.5rem;\n  background: #00703C;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.ticket-close-btn:hover { background: #005a30; }\n\n@media (max-width: 500px) {\n  .ticket-form-row { grid-template-columns: 1fr; }\n  .ticket-modal    { padding: 1.4rem; }\n}\n/* ── Group pricing tiers ── */\n.pricing-tiers {\n  background: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n}\n\n.pricing-tiers-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #444;\n  margin: 0 0 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.pricing-tiers-grid { display: flex; flex-direction: column; gap: 4px; }\n\n.tier-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n  padding: 4px 0;\n  border-bottom: 1px solid #eee;\n  color: #555;\n}\n\n.tier-row:last-child { border-bottom: none; }\n\n.tier-tag {\n  font-size: 11px;\n  font-weight: bold;\n  padding: 2px 8px;\n  border-radius: 10px;\n  background: #e0e0e0;\n  color: #555;\n}\n\n.tier-tag.green { background: #d4edda; color: #155724; }\n.tier-tag.gold  { background: #fff3cd; color: #856404; }\n\n.event-discount-badge {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  background: #ffc107;\n  color: #333;\n  font-size: 11px;\n  font-weight: bold;\n  padding: 3px 10px;\n  border-radius: 20px;\n}\n\n/* ── Lead booker section ── */\n.lead-booker-section {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n/* ── Quantity + price row ── */\n.quantity-row {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.price-summary { width: 100%; }\n\n.discount-badge {\n  background: #d4edda;\n  color: #155724;\n  border-radius: 6px;\n  padding: 6px 10px;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  text-align: center;\n}\n\n/* ── Attendee rows ── */\n.attendees-section {\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n\n.attendees-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n  margin: 0;\n  padding: 0.75rem 1rem;\n  background: #f0f7f0;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.attendee-row {\n  display: flex;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #f0f0f0;\n  align-items: flex-start;\n}\n\n.attendee-row:last-child { border-bottom: none; }\n\n.attendee-number {\n  font-size: 13px;\n  font-weight: bold;\n  color: #00703C;\n  min-width: 24px;\n  padding-top: 28px;\n}\n\n.attendee-fields { flex: 1; display: flex; flex-direction: column; gap: 8px; }\n\n/* ── Success attendees list ── */\n.attendees-summary {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  margin: 0.75rem 0;\n  text-align: left;\n}\n\n.attendees-summary-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #444;\n  margin: 0 0 0.5rem;\n}\n\n.attendee-summary-row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 13px;\n  color: #555;\n  padding: 3px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.attendee-summary-row:last-child { border-bottom: none; }\n\n.green-text { color: #28a745; }\n/* ── Package selector ── */\n.package-selector {\n  margin-bottom: 1rem;\n}\n\n.package-selector-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 0.25rem;\n}\n\n.package-selector-sub {\n  font-size: 12px;\n  color: #888;\n  margin: 0 0 0.75rem;\n}\n\n.packages-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 10px;\n  margin-bottom: 0.75rem;\n}\n\n.package-card {\n  border: 2px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 0.85rem 0.75rem;\n  text-align: center;\n  background: #fff;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n}\n\n.package-card:hover:not(:disabled) {\n  border-color: #00703C;\n  background: #f0f7f0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0,112,60,0.15);\n}\n\n.package-card.selected {\n  border-color: #00703C;\n  background: #e8f5e9;\n  box-shadow: 0 4px 12px rgba(0,112,60,0.2);\n}\n\n.package-card.sold-out {\n  opacity: 0.5;\n  cursor: not-allowed;\n  background: #f5f5f5;\n}\n\n.package-name {\n  font-size: 16px;\n  font-weight: 800;\n  color: #1a1a2e;\n  margin-bottom: 4px;\n}\n\n.package-size {\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 6px;\n}\n\n.package-price {\n  font-size: 15px;\n  font-weight: 700;\n  color: #00703C;\n}\n\n.package-per-person {\n  font-size: 11px;\n  color: #888;\n  margin-top: 2px;\n}\n\n.package-description {\n  font-size: 11px;\n  color: #555;\n  margin-top: 6px;\n  font-style: italic;\n}\n\n.package-sold-out {\n  font-size: 11px;\n  color: #dc3545;\n  font-weight: bold;\n  margin-top: 4px;\n}\n\n.package-selected-tick {\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  font-size: 12px;\n  color: #00703C;\n  font-weight: bold;\n}\n\n.clear-package-btn {\n  background: none;\n  border: none;\n  color: #888;\n  font-size: 12px;\n  cursor: pointer;\n  padding: 0;\n  text-decoration: underline;\n  margin-bottom: 0.5rem;\n}\n\n.clear-package-btn:hover { color: #dc3545; }\n\n.package-divider {\n  text-align: center;\n  color: #bbb;\n  font-size: 12px;\n  margin: 0.75rem 0 0.5rem;\n}\n\n/* ── Selected package banner ── */\n.selected-package-banner {\n  background: #e8f5e9;\n  border: 1px solid #00703C;\n  border-radius: 8px;\n  padding: 10px 14px;\n  font-size: 14px;\n  color: #1a1a2e;\n  margin-bottom: 1rem;\n}\n.quantity-input-row {\n  display: flex;\n  align-items: center;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  overflow: hidden;\n  width: fit-content;\n}\n\n.qty-btn {\n  width: 42px;\n  height: 42px;\n  background: #f0f0f0;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n  color: #333;\n  transition: background 0.2s;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.qty-btn:hover { background: #ddd; }\n\n.qty-input {\n  width: 60px;\n  height: 42px;\n  text-align: center;\n  border: none;\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n  font-size: 16px;\n  outline: none;\n}\n\n.attendee-booker-note {\n  font-size: 12px;\n  color: #888;\n  font-style: italic;\n  padding: 0 1rem 0.5rem;\n  margin: 0;\n  background: #f0f7f0;\n}\n\n.package-selector { margin-bottom: 1rem; }\n.package-selector-title { font-size: 15px; font-weight: 700; color: #1a1a2e; margin: 0 0 0.25rem; }\n.package-selector-sub { font-size: 12px; color: #888; margin: 0 0 0.75rem; }\n\n.packages-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 10px;\n  margin-bottom: 0.75rem;\n}\n\n.package-card {\n  border: 2px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 0.85rem 0.75rem;\n  text-align: center;\n  background: #fff;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n}\n\n.package-card:hover:not(:disabled) {\n  border-color: #00703C;\n  background: #f0f7f0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0,112,60,0.15);\n}\n\n.package-card.selected { border-color: #00703C; background: #e8f5e9; }\n.package-card.sold-out { opacity: 0.5; cursor: not-allowed; background: #f5f5f5; }\n.package-name { font-size: 16px; font-weight: 800; color: #1a1a2e; margin-bottom: 4px; }\n.package-size { font-size: 12px; color: #666; margin-bottom: 6px; }\n.package-price { font-size: 15px; font-weight: 700; color: #00703C; }\n.package-per-person { font-size: 11px; color: #888; margin-top: 2px; }\n.package-description { font-size: 11px; color: #555; margin-top: 6px; font-style: italic; }\n.package-sold-out { font-size: 11px; color: #dc3545; font-weight: bold; margin-top: 4px; }\n.package-selected-tick { position: absolute; top: 6px; right: 8px; font-size: 12px; color: #00703C; font-weight: bold; }\n\n.clear-package-btn {\n  background: none; border: none; color: #888;\n  font-size: 12px; cursor: pointer; padding: 0;\n  text-decoration: underline; margin-bottom: 0.5rem;\n}\n.clear-package-btn:hover { color: #dc3545; }\n.package-divider { text-align: center; color: #bbb; font-size: 12px; margin: 0.75rem 0 0.5rem; }\n\n.selected-package-banner {\n  background: #e8f5e9; border: 1px solid #00703C;\n  border-radius: 8px; padding: 10px 14px;\n  font-size: 14px; color: #1a1a2e; margin-bottom: 1rem;\n}\n\n.pricing-tiers { background: #f8f9fa; border: 1px solid #e0e0e0; border-radius: 8px; padding: 0.75rem 1rem; margin-bottom: 1rem; }\n.pricing-tiers-title { font-size: 13px; font-weight: 600; color: #444; margin: 0 0 0.5rem; display: flex; align-items: center; gap: 5px; }\n.pricing-tiers-grid { display: flex; flex-direction: column; gap: 4px; }\n.tier-row { display: flex; justify-content: space-between; align-items: center; font-size: 13px; padding: 4px 0; border-bottom: 1px solid #eee; color: #555; }\n.tier-row:last-child { border-bottom: none; }\n.tier-tag { font-size: 11px; font-weight: bold; padding: 2px 8px; border-radius: 10px; background: #e0e0e0; color: #555; }\n.tier-tag.green { background: #d4edda; color: #155724; }\n.tier-tag.gold  { background: #fff3cd; color: #856404; }\n\n.event-discount-badge { position: absolute; bottom: 10px; left: 10px; background: #ffc107; color: #333; font-size: 11px; font-weight: bold; padding: 3px 10px; border-radius: 20px; }\n.lead-booker-section { background: #f8f9fa; border-radius: 8px; padding: 1rem; margin-bottom: 1rem; }\n.quantity-row { display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 1rem; }\n.price-summary { width: 100%; }\n.discount-badge { background: #d4edda; color: #155724; border-radius: 6px; padding: 6px 10px; font-size: 13px; font-weight: 600; margin-bottom: 0.5rem; text-align: center; }\n\n.attendees-section { border: 1px solid #e0e0e0; border-radius: 8px; overflow: hidden; margin-bottom: 1rem; }\n.attendees-title { font-size: 14px; font-weight: 600; color: #333; margin: 0; padding: 0.75rem 1rem; background: #f0f7f0; border-bottom: 1px solid #e0e0e0; }\n.attendee-row { display: flex; gap: 0.75rem; padding: 0.75rem 1rem; border-bottom: 1px solid #f0f0f0; align-items: flex-start; }\n.attendee-row:last-child { border-bottom: none; }\n.attendee-number { font-size: 13px; font-weight: bold; color: #00703C; min-width: 30px; padding-top: 28px; }\n.attendee-fields { flex: 1; display: flex; flex-direction: column; gap: 8px; }\n\n.attendees-summary { background: #f8f9fa; border-radius: 8px; padding: 0.75rem 1rem; margin: 0.75rem 0; text-align: left; }\n.attendees-summary-title { font-size: 13px; font-weight: 600; color: #444; margin: 0 0 0.5rem; }\n.attendee-summary-row { display: flex; justify-content: space-between; font-size: 13px; color: #555; padding: 3px 0; border-bottom: 1px solid #eee; }\n.attendee-summary-row:last-child { border-bottom: none; }\n.green-text { color: #28a745; }\n/* ── Description clamp on card ── */\n.event-description-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  margin-bottom: 0.4rem;\n}\n\n.read-more-link {\n  display: inline-block;\n  font-size: 0.82rem;\n  color: #00703C;\n  font-weight: 600;\n  cursor: pointer;\n  margin-bottom: 0.75rem;\n  transition: color 0.15s;\n}\n\n.read-more-link:hover { color: #005a30; text-decoration: underline; }\n\n/* ── Event Detail Modal ── */\n.event-detail-modal {\n  background: #fff;\n  border-radius: 14px;\n  width: 100%;\n  max-width: 620px;\n  margin: auto;\n  position: relative;\n  animation: slideUp 0.25s ease;\n  overflow: hidden;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.event-detail-image {\n  position: relative;\n  height: 240px;\n  overflow: hidden;\n  background: #f0f0f0;\n  flex-shrink: 0;\n}\n\n.event-detail-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.event-detail-body {\n  padding: 1.5rem 1.75rem 1.75rem;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.event-detail-title {\n  font-size: 1.5rem;\n  color: #1a1a2e;\n  margin: 0 0 1rem;\n  padding-right: 1.5rem; /* avoid overlap with X button */\n  line-height: 1.3;\n}\n\n.event-detail-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #eee;\n}\n\n.event-detail-meta div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.9rem;\n  color: #555;\n}\n\n.event-detail-description {\n  margin-bottom: 1.5rem;\n}\n\n.event-detail-description h4 {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: #1a1a2e;\n  margin: 0 0 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.event-detail-description p {\n  font-size: 0.95rem;\n  color: #444;\n  line-height: 1.7;\n  margin: 0;\n  white-space: pre-wrap;\n}\n\n.event-detail-actions {\n  margin-top: 0.5rem;\n}\n\n@media (max-width: 640px) {\n  .event-detail-modal { max-height: 95vh; border-radius: 10px 10px 0 0; }\n  .event-detail-image { height: 180px; }\n  .event-detail-body  { padding: 1.2rem 1.2rem 1.5rem; }\n  .event-detail-title { font-size: 1.25rem; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
